export const SECTION_TEMPLATE_DETAILS = 'src/components/Scorecard/SectionTemplate/create/action/Section_Template_Details';
export const SECTION_TEMPLATE_DETAILS_SUCCESS = 'src/components/Scorecard/SectionTemplate/create/action/Section_Template_Details_Success';
export const SECTION_TEMPLATE_DETAILS_FAILURE = 'src/components/Scorecard/SectionTemplate/create/action/Section_Template_Details_Failure';
export const getSectionTemplateDetails = (data) => {
    return {
        type: SECTION_TEMPLATE_DETAILS,
        data
    }
}
export const fetchSectionTemplateSuccess = (data) => {
    return {
        type: SECTION_TEMPLATE_DETAILS_SUCCESS,
        data
    }
}
export const fetchSectionTemplateError = (data) => {
    return {
        type: SECTION_TEMPLATE_DETAILS_FAILURE,
        data
    }
}

export const SECTION_TEMPLATE_ID = 'src/components/Scorecard/SectionTemplate/create/action/Section_Template_ID';
export const setSectionTemplateExternalId = (data) => {
    return {
        type: SECTION_TEMPLATE_ID,
        data
    }
}
// export const  SECTION_TEMPLATE_FILE_DOWNLOAD = 'src/components/Scorecard/SectionTemplate/create/action/Section_Template_File_Download';
export const  SECTION_TEMPLATE_FILE_DOWNLOAD_SUCCESS = 'src/components/Scorecard/SectionTemplate/create/action/Section_Template_File_Download_Success';
export const  SECTION_TEMPLATE_FILE_DOWNLOAD_FAILURE = 'src/components/Scorecard/SectionTemplate/create/action/Section_Template_File_Download_Failure';
export const  downloadSectionTemplateSuccess = (data) => {
    return {
        type: SECTION_TEMPLATE_FILE_DOWNLOAD_SUCCESS,
        data
    }
}
export const  downloadSectionTemplateFailure = (data) => {
    return {
        type: SECTION_TEMPLATE_FILE_DOWNLOAD_FAILURE,
        data
    }
}